import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import loanFormModel from '../../../../../../../components/loan_application/form_models/loanFormModel';
import * as Yup from 'yup';
import PrincipalTypeValidation from './PrincipalTypeValidation';
import PrincipalTrustNameValidation from './PrincipalTrustNameValidation';
import PrincipalOccupationValidation from './PrincipalOccupationValidation';
import PrincipalOtherOccupationValidation from './PrincipalOtherOccupationValidation';
import PrincipalAddressValidation from './PrincipalAddressValidation';
import PrincipalBirthdateValidation from './PrincipalBirthdateValidation';
import PrincipalIsUSCitizenValidation from './PrincipalIsUSCitizenValidation';
import PrincipalNonUSPersonIdNumberValidation from './PrincipalNonUSPersonIdNumberValidation';
import PrincipalNonUSPersonIssuanceCountryValidation from './PrincipalNonUSPersonIssuanceCountryValidation';
import PrincipalSsnValidation from './PrincipalSsnValidation';
import PrincipalPhoneNumberValidation from './PrincipalPhoneNumberValidation';
import PrincipalCityValidation from './PrincipalCityValidation';
import PrincipalStateValidation from './PrincipalStateValidation';
import PrincipalCountryValidation from './PrincipalCountryValidation';
import PrincipalMortgagePaymentValidation from './PrincipalMortgagePaymentValidation';
import PrincipalRentValidation from './PrincipalRentValidation';
import PrincipalLiquidAssetsValidation from './PrincipalLiquidAssetsValidation';
import PrincipalPGAgreementValidation from './PrincipalPGAgreementValidation';
import PrincipalAnnualGrossIncomeValidation from './PrincipalAnnualGrossIncomeValidation';
import ApplicantSameAsPrincipalValidation from './ApplicantSameAsPrincipalValidation';
import PrincipalIsPGValidation from './PrincipalIsPGValidation';
import PrincipalPercentOwnedValidation from './PrincipalPercentOwnedValidation';
import PrincipalFirstNameValidation from './PrincipalFirstNameValidation';
import PrincipalLastNameValidation from './PrincipalLastNameValidation';
import PrincipalZipValidation from './PrincipalZipValidation';
import PrincipalIdDocumentFileNameValidation from './PrincipalIdDocumentFileNameValidation';
import PrincipalRentOrOwnValidation from './PrincipalRentOrOwnValidation';
import PropertyOwnerPercentOwnershipValidation from './PropertyOwnerPercentOwnershipValidation';
import PrincipalEmailValidation from './PrincipalEmailValidation';
import PrincipalCertificateOfTrustValidation from './PrincipalCertificateOfTrustValidation';
import {
  RELATED_PARTY_RELATIONSHIP,
  RELATED_PARTY_TYPES,
} from '../../../../../../../constants';

const {
  formField: {
    // Principal
    principalMiddleInitial,

    // Personal Guarantor

    principalIdDocument,
    principalCertificateOfTrust,
  },
} = loanFormModel;

export class PrincipalsValidation implements ValidationSchema {
  public name = 'principals';
  public label = '';
  public dependsOn: string[] = [];
  public type = 'array';
  public required = {
    message: '',
    value: false,
  };
  public nullable = false;

  public when(schema: Yup.ArraySchema<Yup.ObjectSchema<any>>) {
    const validations = [
      PrincipalTypeValidation,
      PrincipalTrustNameValidation,
      PrincipalOccupationValidation,
      PrincipalOtherOccupationValidation,
      PrincipalAddressValidation,
      PrincipalBirthdateValidation,
      PrincipalIsUSCitizenValidation,
      PrincipalNonUSPersonIdNumberValidation,
      PrincipalNonUSPersonIssuanceCountryValidation,
      PrincipalSsnValidation,
      PrincipalPhoneNumberValidation,
      PrincipalEmailValidation,
      PrincipalPercentOwnedValidation,
      PrincipalFirstNameValidation,
      PrincipalLastNameValidation,
      PrincipalCityValidation,
      PrincipalStateValidation,
      PrincipalZipValidation,
      PrincipalCountryValidation,
      PrincipalIsPGValidation,
      ApplicantSameAsPrincipalValidation,
      PrincipalAnnualGrossIncomeValidation,
      PrincipalLiquidAssetsValidation,
      PrincipalRentValidation,
      PrincipalRentOrOwnValidation,
      PrincipalMortgagePaymentValidation,
      PrincipalPGAgreementValidation,
      PropertyOwnerPercentOwnershipValidation,

      // TODO: Uncomment these back when CRB requires it - Ticket #2391
      // EthnicityValidation,
      // SubEthnicityValidation,
      // OtherEthnicityValidation,
      // SexGenderValidation,
      // RaceValidation,
      // SubRaceValidation,
      // OtherRaceValidation,
    ];

    const validationSchema: Record<string, any> = validations.reduce(
      (schema, validation) => {
        schema[validation.name] = validation.buildSchema();
        return schema;
      },
      {}
    );

    validationSchema[principalMiddleInitial.name] = Yup.string().nullable();
    validationSchema.documents = Yup.object()
      .shape({
        [principalIdDocument.name]: Yup.object()
          .test(
            'required-if-individual',
            'This document is required',
            function (value: any, context: any) {
              const principalType = (this as any).from?.[2]?.value[
                'principal_type'
              ];
              const principalRelationship = (this as any).from[2].value[
                'relationship'
              ];
              if (
                principalType === RELATED_PARTY_TYPES.INDIVIDUAL &&
                principalRelationship !== RELATED_PARTY_RELATIONSHIP.LANDLORD
              ) {
                return (
                  value && value.files && (value.files as any[])?.length > 0
                );
              }
              return true;
            }
          )
          .shape({
            files: Yup.array().of(
              Yup.object().shape({
                file_name: PrincipalIdDocumentFileNameValidation.buildSchema(),
              })
            ),
          }),
        [principalCertificateOfTrust.name]: Yup.object()
          .test(
            'required-if-entity',
            'This document is required',
            function (value, context) {
              const principalType = (this as any).from?.[2]?.value[
                'principal_type'
              ];
              const principalRelationship = (this as any).from[2].value[
                'relationship'
              ];
              const document = (this as any).from?.[2].value.documents?.[
                principalCertificateOfTrust.name
              ];
              if (
                principalType === RELATED_PARTY_TYPES.ENTITY &&
                principalRelationship !== RELATED_PARTY_RELATIONSHIP.LANDLORD
              ) {
                return (
                  document &&
                  document.files &&
                  (document.files as any[])?.length > 0
                );
              }
              return true;
            }
          )
          .shape({
            files: PrincipalCertificateOfTrustValidation.buildSchema(),
          }),
      })
      .required();

    return schema.of(Yup.object().shape(validationSchema)).required();
  }
}
export default new Validation(new PrincipalsValidation());
